module.exports = __webpack_public_path__ + "static/media/M22_social_white_on_red.c745fde8.png";